var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 17.7)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4.3h98.7v110.4H.4z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.8 1.3C42.9-.2 62.4.1 73.5 1.3c15.1 1.7 23 6.7 24 22 1 15.4 1.6 37.4 1.6 45.4s-3.3 14.7-11 17c-7.6 2.3-9.3 6.7-10.3 12.7-1 6-4.7 12-18.7 12.3C45.1 111 .4 103 .4 103s4.3-52.6 4.7-69.7c.3-20.9 2.7-29.5 24.7-32",
    fill: "#EEE",
    mask: "url(#account_advanced__b)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 88.7)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8.8h114.1V50H.8z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 50c-6-.5-10.7-5.7-5.5-14.5C8 26.7 17.3 13.5 41 10.3c23.9-3.1 23.6 3.8 35.5 3.3C87.4 13 87.4 5 87.8 3.6c.5-1.6 1.6-3 4.8-2.7 3.2.4 17.2 2.3 19 3 1.7.6 3.4 1.4 3.3 5.2-.1 3.7-3.2 40.9-48 40.9H8.5z",
    fill: "#00D4B5",
    mask: "url(#account_advanced__d)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101 70.3c-1 .3-6.2 4.3-6 10.7.4 6.4 4.2 11.2 12.2 11.9 8 .7 14.4-.8 17.5-5.8 3.1-5 1.5-10.3.7-11.1-.8-1-7.8-2.2-8.8-2.2-1 .1-1.3.8-1.2 2.2 0 1.3.8 9-5.8 7.6-6.5-1.4-3.4-7.2-1.1-9.4 1.4-1.4 0-2.8-1.4-3.1-1.4-.4-4.3-1.4-6.1-.8",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 47.7)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .7h69.5v52.1H0z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 10.9c7.7-1.7 40.3-9 45.4-10 4.8-.8 10.4.2 11.8 5 0 0-3.4 8-3.3 8.3.7 4.5 5.3 8.2 5.3 8.2v3.4c0 5.2-2 21.1-27.5 25.8-20.8 3.8-35.7-.8-40.6-19-3.8-14 1.2-20 9-21.7",
    fill: "#00D4B5",
    mask: "url(#account_advanced__f)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.9 54.7c0-5.8-.3-11.3 2.6-11.3 2.8 0 6.3 9.3 6.3 9.3l-9 2zM19.6 74c1 5.4 3.6 7.4 12 5.9 7-1.3 35.2-8 43.8-9.8a143.9 143.9 0 0 0-2-16.5C66.6 55.1 31.7 63 27.8 64c-7.3 1.7-9.3 4.6-8.2 10",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 38.3c.5-2.6 2.8-4 5.2-3.5 2.7.5 4.2 2.7 3.7 5.2-.6 2.5-2.6 4-5.3 3.6-2.6-.4-4.1-2.6-3.6-5.3",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 84.9c.5-2.7 2.8-4 5.3-3.5 2.7.5 4.2 2.7 3.6 5.2-.5 2.4-2.5 4-5.2 3.6-2.6-.4-4.2-2.6-3.7-5.3",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6 50.8c3.2-3.3 7.8-2.9 10.8.1 0 0 1.2 6.2-2 9-3 3-8.9 1.8-8.9 1.8-3.2-3.1-3.2-7.7 0-11",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5 61.7c3.4 3.1 7.8 3 11 0 3-2.9 3.2-7.5-.1-10.8l-10.9 10.8z",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4 41c-3.2-3.2-2.8-7.8.2-10.8 0 0 5-.1 8 3s2.7 7.9 2.7 7.9c-3 3.2-7.6 3.2-10.9 0",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3 41c3.2-3.3 3-7.6 0-10.8-2.8-3.1-7.4-3.2-10.7 0l10.7 10.9z",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4 35.6c0-4.6 3.5-7.6 7.7-7.6 0 0 5 3.4 4.8 7.7-.1 4.3-4.8 7.6-4.8 7.6-4.5.1-7.7-3.1-7.7-7.7",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 43.3a7.6 7.6 0 0 0 7.8-7.7c.1-4.2-3-7.5-7.7-7.6v15.3zM101.3 29.1L95 37.9c-1.3 1.8 0 3.3 1.7 3.3h10.5c1.7 0 2.7-1.9 1.7-3.3l-6-8.8a1 1 0 0 0-1.6 0",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 62.4h-9a2.5 2.5 0 0 1-2.5-2.6V53c0-1.9 1.6-2.9 3-2.9h9c1.4 0 2.5 1.1 2.5 2.5v7.2c0 1.5-1.2 2.6-3 2.6",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9 97.8c.1-3.8-1.6-4.6-3.4-5.3-1.7-.6-15.7-2.5-19-3-3.1-.3-4.2 1.2-4.7 2.8-.4 1.5-.4 9.5-11.2 10-3 .1-5.1-.2-7.1-.7v37a43 43 0 0 0 45.4-40.8",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 73.7a1.5 1.5 0 0 1-.3-3l40.2-8.9c.8-.2 1.6.4 1.8 1.2.2.8-.3 1.6-1.2 1.8l-40.2 8.8h-.3",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 119.7h-25a1.3 1.3 0 0 1 0-2.5h25a1.3 1.3 0 0 1 0 2.5M58.5 113.6H42a1.3 1.3 0 0 1 0-2.5h16.4a1.3 1.3 0 0 1 0 2.5M58.5 125.8H42a1.3 1.3 0 0 1 0-2.5h16.4a1.3 1.3 0 0 1 0 2.5M75.5 135.7a.8.8 0 0 1-.8-.8v-28a.8.8 0 0 1 1.5 0v28c0 .5-.3.8-.7.8M79.4 135.7a.8.8 0 0 1-.8-.8v-28a.8.8 0 0 1 1.5 0v28c0 .5-.3.8-.7.8M25 135.7a.8.8 0 0 1-.8-.8v-22.6a.8.8 0 0 1 1.5 0V135c0 .5-.3.8-.7.8M21.2 135.7a.8.8 0 0 1-.7-.8v-19.6a.8.8 0 0 1 1.5 0v19.6c0 .5-.4.8-.8.8",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced);
export default __webpack_public_path__ + "static/media/advanced.f41eceaaa0bb27677fb029eb3e89af88.svg";
export { ForwardRef as ReactComponent };